import { useContext, useEffect, useState } from "react";
import React from "react";
import server from "../../../server";
import UserLoginContext from "../../../context/userLoginContext";
import Clock from "../employee-punch-card/components/clock";
import HeaderBackgroundDrawer from "./header-background-drawer";

interface IQuote {
    quote: string;
    author: string;
}

const Quotes = () => {

    const [quotes, setQuotes] = useState<IQuote | null>(null);
    const [open, setOpen] = useState<boolean>(false);
    const [bgImage, setBgImage] = useState<string>('');

    const {user} = useContext(UserLoginContext);


    useEffect(() => {
        fetchQuotes();
        fetchBgImgUrl();
    }, []);


    const ImgStorageKey = React.useMemo(() => {
        if (user.isAdmin) {
            return `pn-header-url-admin-${user.id}`;
        }

        if (user.employeeId) {
            return `pn-header-url-${user.employeeId}`;
        }

        return `pn-header-url-${user.id}`;
    }, [user]);


    const quoteId = (new Date().getDate() % 30) + 1;

    async function fetchQuotes() {
        try {
            const dailyQuotes = await server.utils.quotes.get(quoteId);
            setQuotes(dailyQuotes);
        } catch (e) {
            console.log("Error while fetching quotes", e)
        }
    }

    function getCurrentGreeting() {
        const currentHour = new Date().getHours();
        if (currentHour < 12) {
            return "Good morning!";
        } else if (currentHour < 18) {
            return "Good afternoon!";
        } else {
            return "Good evening!";
        }
    }

    const todayDate = new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });

    const todayDay = new Date().toLocaleDateString("en-US", {
        weekday: "long",
    });

    function onDrawerClose() {
        setOpen(false)
    }

    function onImageSelect(url: string) {
        setBgImage(url);
    }

    function fetchBgImgUrl() {
        let imgUrl = '';
        const storedUrl = localStorage.getItem(ImgStorageKey);
        imgUrl = storedUrl ? storedUrl : "/images/quote-bg.jpg";
        setBgImage(imgUrl);
    }

    function onSubmit() {
        localStorage.setItem(ImgStorageKey, bgImage);
    }

    return (
        <>
            <div className={"dashboard-quote-container"}
                 style={{
                     backgroundImage: `url(${bgImage})`,
                     backgroundSize: "cover",
                     backgroundPosition: "center",
                 }}
                 onClick={() => setOpen(true)}>
                <div>
                    <div className={"dashboard-greeting-container"}>
                        <h2>
                            {getCurrentGreeting()}
                        </h2>

                    </div>
                    {quotes && (
                        <div className="dashboard-quote">
                            <p>"{quotes.quote}"</p>
                            <p>- {quotes.author}</p>
                        </div>
                    )}
                </div>

                {
                    user?.isAdmin && <div className={"admin-dashboard-date-time"}>
                        <p className={"dashboard-today-date"}>{todayDate}</p>
                        <Clock/>
                        <p className={"dashboard-today-day"}>{todayDay}</p>
                    </div>
                }

            </div>
            <HeaderBackgroundDrawer
                open={open}
                onClose={onDrawerClose}
                onImageSelect={onImageSelect}
                currImgUrl={bgImage}
                onSubmit={onSubmit}
            />

        </>
    )
}

export default Quotes;
